import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, FormGroup, NgForm, Validators, FormControl } from '@angular/forms';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectService } from 'src/app/_services/project.service';
import { DOCUMENT } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/test/test-step/confirmation-dialog.service';
import { SettingService } from 'src/app/_services/setting.service';
import { UrlService } from 'src/app/_services/url.service';
import { MemoryService } from 'src/app/_services/memory.service';
import { HomeService } from 'src/app/_services/home.service';
// import { Console } from 'console';
declare var $: any;
@Component({
  selector: 'app-party-integration',
  templateUrl: './party-integration.component.html',
  styleUrls: ['./party-integration.component.scss']
})
export class PartyIntegrationComponent implements OnInit {
  projectId: string;
  projectData: any;
  projectSettingData: any;
  TestEnvData: any;
  bugLoggingData: any;
  bugZillaData: any;
  gitLabData: any;
  jiraData: any;
  tfsData: any;
  testLabData: any;
  bugLoggingSysData: any;
  bugLogging: true;
  // editProjectSettingForm:FormGroup;
  bugLogDir = ["JIRA", "TFS", "GITLAB", "BUGZILLA", "TFS_PAT"];
  bugLogggingGroup = ["Auto", "SemiAuto", "Manual"];

  testLabOption = [
    {
      value: 'Local',
      text: 'Local'
    }, {
      value: 'SauceLab',
      text: 'SauceLab'
    }, {
      value: 'Perfecto',
      text: 'Perfecto',
    }, {
      value: 'Headspin',
      text: 'Headspin',
    }, {
      value: 'Browserstack',
      text: 'Browserstack',
    }
  ];
  headerOptions = {
    showSetting : false,
    showSearch: false,
    heading : 'Settings',
    data: undefined,
  }


  submitted: boolean;
  bugLoggingSettingData: any;
  bugDataToEdit: any;
  bugDataValue: any;
  isMasked: boolean;
  settingTestEnvData: any;
  updateSettingData: any;
  PropertyName: any;
  formObj: any;
  bugLoggingUpdate: any;
  isInputTypePassword: boolean = false;
  unmaskedValue: any;
  nonEmptyFeildsData: any;
  @ViewChild('cancelmodal', null) cancelmodal: ElementRef;
  currentUrl: any;
  previousUrl: any =[];
  previousUrltemp: any;
  enableEditPopup = false;
  agentCheck: boolean;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private http: HttpClient,
    private route: ActivatedRoute,
    private project: ProjectService,
    private toastrService: ToastrService,
    private confirmationDialogService: ConfirmationDialogService,
    private setting: SettingService,
    private router: Router,
    private urlService: UrlService,
    private memoryService: MemoryService,
    private homeService: HomeService,
    @Inject(DOCUMENT) private document: Document) {
    this.route.paramMap.subscribe(
      params => {
        this.projectId = params.get('pid');
        this.project.getProjectById(this.projectId).subscribe((
          data => {
            this.projectData = data;
            this.headerOptions.data = {
              projectId: this.projectId,
              projectName: data['projectName']
            };
            //set header details
            this.homeService.setHeaderOptions(this.headerOptions);
            //console.log(this.projectData);
            this.getAllprojectSetting(this.projectId)
            this.getUnmaskable();
            this.getNonEmptyFeilds();
          }
        ))

      }
    )
  }

  ngOnInit() {
    this.memoryService.getAgentCheck().subscribe((res)=>
    {
      this.agentCheck = res;
    })
    if(this.agentCheck)
    {
      this.memoryService.getUrlHistory().subscribe((res)=>
      {
        this.previousUrl =  res;
        if(this.previousUrl.length > 0)
        {
          this.currentUrl =  this.router.url;
          this.previousUrltemp= this.urlService.captureUrl(this.currentUrl);
          this.memoryService.setUrlHistory(this.previousUrltemp);
        }
      })
    }
    else
    {
      this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      if(!this.previousUrl){
        this.currentUrl =  this.router.url;
        this.previousUrltemp= this.urlService.captureUrl(this.currentUrl);
        localStorage.setItem('urlHistory', JSON.stringify(this.previousUrltemp));
        this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      }
    }
  }
  geturlName(url) {
    return this.urlService.geturlName(url);
  }

  getAllprojectSetting(projectId) {
    this.setting.getAllProjectSetting(projectId).subscribe(
      (data) => {
        this.projectSettingData = data['projectSettingList'];
        //console.log('allSettingData',this.projectSettingData);
        this.TestEnvData = this.projectSettingData.filter((f) => f.name == 'envSetting')
        this.bugLoggingSysData = this.projectSettingData.filter((f) => f.name == 'cSetting');
        this.bugLoggingUpdate = this.bugLoggingSysData;
        this.settingTestEnvData = this.TestEnvData;
        this.TestEnvData = this.TestEnvData[0].setting.entry;

        this.bugLoggingData = this.TestEnvData.filter((f) => f.key.includes('bug_'));
        this.bugZillaData = this.TestEnvData.filter((f) => f.key.includes('bugzilla'));
        this.gitLabData = this.TestEnvData.filter((f) => f.key.includes('gitlab'));
        this.jiraData = this.TestEnvData.filter((f) => f.key.includes('jira'));
        this.tfsData = this.TestEnvData.filter((f) => f.key.includes('tfs'));
      
        if (this.projectData['projectType'] == 'MOBILE' || this.projectData['projectType'] == 'MIXED') {
          //console.log(this.projectSettingData);
          let testLab = this.projectSettingData.filter((f) => f['@type'] == 'mobileSetting');
          //console.log(testLab);
          this.testLabData = testLab[0].setting.entry.filter((f) => f.key.includes('testLab'));
          //console.log("output 1 : ", this.testLabData);
        }
        else {
          this.testLabData = undefined;
        }

        this.bugLoggingSettingData = this.bugLoggingSysData[0].setting;
        this.bugLoggingSysData = this.bugLoggingSettingData.entry.filter((f) => f.key.includes('bug_'));
        //console.log(this.bugLoggingData);
        //console.log(this.bugLoggingSysData);
      }
    )
  }
  filterBugLog(bugDataToEdit, bugDataValue, isMasked = 'false') {
    
    this.bugDataToEdit = bugDataToEdit;
    this.bugDataValue = bugDataValue;
    this.isMasked = isMasked == 'false' ? false : true;

    if (isMasked == 'true' && this.bugDataValue !='') {
      this.enableEditPopup = false;
      this.toastrService.clear();
      this.toastrService.info('please decrypt and then try to edit');
      return;
    }
  
    else
    {
      this.enableEditPopup = true;
      $(document).ready(() => {
         $('#editPartySetting').modal('show');
      });
    }
    this.updateSettingData = this.TestEnvData.filter((f) => f.key == bugDataToEdit)

    if (this.testLabData) {
      var testLabData = this.testLabData.filter((f) => f.key == bugDataToEdit);
      if (testLabData[0]) {
        this.updateSettingData = testLabData;
      }

    }

    if (this.updateSettingData.length > 0 && this.updateSettingData[0].value.isMasked == 'true') {
      this.isInputTypePassword = true;
    }
    else if (this.updateSettingData.length > 0 && this.updateSettingData[0].value.isMasked == 'false') {
      this.isInputTypePassword = false;
    }
    else {
      this.isInputTypePassword = false;
    }
    //console.log(this.settingTestEnvData);
    if (bugDataToEdit == 'bug_logging') {
      this.updateSettingData = this.bugLoggingSysData.filter((f) => f.key == bugDataToEdit)
      //console.log(this.updateSettingData);
    }
   
  }
  openBugLogModel() {

  }
  openBugSysModel() {

  }
  // loadForm(){

  //   this.editProjectSettingForm = this.formBuilder.group({
  //     bug_logging_system:[]
  //   })
  // }
  //  get f() { return this.editProjectSettingForm.controls; }

  getUnmaskable() {
    this.setting.getUnMaskedValue().subscribe(
      (data) => {
        this.unmaskedValue = data['unmaskableField'];
        //console.log(this.unmaskedValue)
      }
    )
  }

  getNonEmptyFeilds() {
    this.setting.nonEmptyFeilds().subscribe(
      (data) => {
        this.nonEmptyFeildsData = data['nonemptyfields'];
        //console.log(this.nonEmptyFeildsData);
      }
    )
  }

  getMaskedValue(key, value, type,isMasked?:any) {

    //console.log(key, 'value>', value);
    if (value.trim() === '') {
      this.toastrService.clear();
      this.toastrService.info('Empty Value cannot be Encrypted');
      return;
    }

    if (type == 'bugzilla') {
      this.updateSettingData = this.bugZillaData.filter((f) => f.key == key)
    }
    else if (type == 'gitlab') {
      this.updateSettingData = this.gitLabData.filter((f) => f.key == key)
    }
    else if (type == 'jira') {
      this.updateSettingData = this.jiraData.filter((f) => f.key == key)
    }
    else if (type == 'tfs') {
      this.updateSettingData = this.tfsData.filter((f) => f.key == key)
    }

    if (this.updateSettingData[0].value.isMasked == 'true') {
      this.updateSettingData[0].value.isMasked = 'false';
      this.setting.decryptSetting(this.projectId, this.updateSettingData[0].value).subscribe(
        (data) => {
          console.log(data);
          this.updateSettingData[0].value = data
          this.project.editProjectSetting(this.projectId, this.settingTestEnvData[0]).subscribe(
            (data) => {
              //console.log(data);
              this.toastrService.clear();
              this.toastrService.success('Automation setting decrypted successfully');
            }
          )
        }
      )

      //console.log('if>', this.updateSettingData);
    }
    else if (this.updateSettingData[0].value.isMasked == 'false') {
      this.updateSettingData[0].value.isMasked = 'true';
      //console.log('else if>', this.updateSettingData);

      this.setting.encryptSetting(this.projectId, this.updateSettingData[0].value).subscribe(
        (data) => {

          this.updateSettingData[0].value = data
          console.log(data);
          this.project.editProjectSetting(this.projectId, this.settingTestEnvData[0]).subscribe(
            (data) => {
              //console.log(data);
              this.toastrService.clear();
              this.toastrService.success('Automation setting encrypted successfully');
            }
          )

        }
      )
    }



  }



  onSubmit(editProjectSettingForm) {

    this.formObj = editProjectSettingForm.value;
    console.log(this.formObj);
    this.updateSettingData[0].value.settingValue = this.bugDataValue;
    this.submitted = true;
    if (this.bugDataToEdit == 'bug_logging') {
      //console.log(this.bugLoggingUpdate)
      this.editProjectSettings(this.projectId, this.bugLoggingUpdate[0]);
    }

    if (this.bugDataToEdit != 'bug_logging') {
      this.editProjectSettings(this.projectId, this.settingTestEnvData[0]);
    }

  }


  editProjectSettings(projectId, settingData)
  { 
   
   
    let selectedSetting = settingData.setting.entry.find((f) => f.key == this.bugDataToEdit)

    if (!this.isMasked) {
        this.project.editProjectSetting(projectId, settingData).subscribe(
            (data) => {
              // console.log('test',data);
              this.toastrService.clear();
              this.toastrService.success('Automation setting saved successfully');
              this.enableEditPopup = false;
              this.cancelmodal.nativeElement.click();
            }
        )
      //console.log('if>', this.updateSettingData);
    }
    else if (this.isMasked) {

      this.setting.encryptSetting(projectId, selectedSetting.value).subscribe(
        (data) => {

          selectedSetting.value = data
          // console.log(data);
          this.project.editProjectSetting(this.projectId, settingData).subscribe(
            (data) => {
              //console.log(data);
              this.toastrService.clear();
              this.toastrService.success('Automation setting saved successfully');
              this.enableEditPopup = false;
              this.cancelmodal.nativeElement.click();
            }
          )

        }
      )
    }

  }

}